<template>
  <v-sheet width="100%" color="transparent">
    <FileSelectWrapper
      :validFormats="$constants.fileAttachments.acceptedFormats"
      @selected="handleSelectedFile"
    >
      <template slot-scope="{ selectFile, isDraggingFile }">
        <v-sheet
          class="d-flex justify-start flex-wrap"
          width="100%"
          color="transparent"
        >
          <TaskAttachmentCard
            v-for="(file, index) in files"
            :key="`${index}_${file.id}`"
            :name="file.originalFileName"
            :size="file.bytes"
            :class="hasAttachments ? 'mt-2' : ''"
            @closeClick="handleDelete(file.attachmentId, file.id)"
            @download="handleDownload(file)"
          />
          <TaskAttachmentCard
            v-for="(file, index) in filesToUpload"
            isLoading
            readOnly
            :key="`${index}_${file.id}`"
            :name="file.name"
            :size="file.size"
            :class="hasAttachments ? 'mt-2' : ''"
          />

          <ThumbnailUploader
            v-if="showTrigger"
            icon="mdi-file-plus"
            :class="hasAttachments ? 'mt-2' : ''"
            :isDraggingFile="isDraggingFile"
            :tooltip="$t('common.upload_file')"
            @select="selectFile"
          />
        </v-sheet>
      </template>
    </FileSelectWrapper>
    <DeleteConfirmationModal
      :show="showDeleteModal"
      :title="$t('fileLoader.delete_file_title')"
      :text="$t('fileLoader.delete_file_message')"
      @cancel="isDeleteConfirmationOpen = false"
      @delete="removeSelectedFile"
    />
  </v-sheet>
</template>
<script>
import MediaSDK from '@/lib/ReverMediaSDK'

import FileSelectWrapper from '@/components/utils/FileSelectWrapper/FileSelectWrapper.vue'
import ThumbnailUploader from '@/components/MediaContainer/ThumbnailUploader.vue'
import DeleteConfirmationModal from '@/components/Modals/DeleteConfirmationModal.vue'
import TaskAttachmentCard from './Tasks/TaskAttachmentCard.vue'

export default {
  name: 'FileUploadContainer',

  components: {
    FileSelectWrapper,
    ThumbnailUploader,
    DeleteConfirmationModal,
    TaskAttachmentCard,
  },

  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fileToDelete: null,
      showDeleteModal: false,
      filesToUpload: [],
    }
  },

  computed: {
    limit() {
      return this.$constants.fileAttachments.defaultLimit
    },

    hasReachedLimit() {
      return this.files.length >= this.limit
    },

    showTrigger() {
      return !this.hasReachedLimit
    },

    hasAttachments() {
      return (
        this.files.length >= 2 ||
        (this.files.length >= 1 && this.filesToUpload.length > 0)
      )
    },
  },

  methods: {
    handleDelete(attachmentId, id) {
      this.fileToDelete = { attachmentId: attachmentId, fileId: id }
      this.showDeleteModal = true
    },

    removeSelectedFile() {
      this.$emit('removeFile', this.fileToDelete)
      this.showDeleteModal = false
      this.fileToDelete = null
    },

    handleDownload(file) {
      MediaSDK.download(file)
    },

    handleError(err = {}) {
      const errors = {
        FORMAT_ERROR: this.$t('attachments.the_file_is_not_supported'),
        SIZE_ERROR: this.$t(
          'attachments.the_file_is_larger_than_the_allowed_file_size'
        ),
        UPLOAD_ERROR: this.$t('attachments.uploading_the_file_failed'),
      }

      this.showError(errors[err.message])
    },

    async uploadFile(file) {
      try {
        return await MediaSDK.uploadMedia(file)
      } catch (err) {
        this.handleError(err)
      } finally {
        this.filesToUpload = []
      }
    },

    async handleSelectedFile(files) {
      this.filesToUpload = [...files]
      const mediaObject = await this.uploadFile(files[0])
      this.$emit('fileSelected', mediaObject)
    },
  },
}
</script>

<style lang="scss" scoped>
.main-section {
  position: relative;
}
</style>
